<template>
  <RbuSectionItemMappingPaginatedList
    :filter-options="filterOptions"
    :headers="headers"
    multi-rbut
    data-url="admin/rbu/item/mapping/"
    data-key="item_mappings"
    :refresh-trigger.sync="innerRefreshTrigger"
    v-bind="$attrs"
    class="rbu-item-list"
  >
    <template #item.dummy_item_no_numeric="{ value }">
      <span>{{ value }}</span>
    </template>
    <template #item.items="{ value }">
      <div style="display: flex; flex-direction: row; gap: 0.75rem">
        <div v-for="(item, idx) in value" :key="idx">
          <span class="styled-span" @click="() => editItem(item)">{{
            item.dummy_item_no
          }}</span>
        </div>
      </div>
    </template>
  </RbuSectionItemMappingPaginatedList>
</template>

<script>
import { onMounted, ref, watch } from "@vue/composition-api";
import RbuSectionItemMappingPaginatedList from "../RbuSectionItemMappingPaginatedList";
import { ACTION_TYPES } from "@/store/types";
import { PERMISSIONS } from "@/constants";

export default {
  name: "RbuItemMappingList",
  components: { RbuSectionItemMappingPaginatedList },
  props: {
    value: Array,
    refreshTrigger: Boolean,
  },
  setup(props, { root, emit }) {
    const refresh = function () {
      innerRefreshTrigger.value = true;
    };
    onMounted(() => {
      refresh(false);
    });

    watch(
      () => props.refreshTrigger,
      (newValue) => {
        if (newValue) {
          refresh(true);
          emit("update:refresh-trigger", false);
        }
      }
    );

    // Filter
    const filterOptions = ref([
      {
        text: root.$t("rbu_item.item_dummy_item_no"),
        value: "dummy_item_no_numeric",
        contains: true,
      },
    ]);

    // Data Table
    const headers = ref([
      {
        text: root.$t("rbu_item.item_dummy_item_no"),
        value: "dummy_item_no_numeric",
        width: "15rem",
      },
      {
        text: root.$t("rbu_item.current_item_no"),
        value: "current_item_no",
        width: "15rem",
      },
      { text: root.$t("rbu_item.variations"), value: "items", sortable: false },
    ]);
    const innerRefreshTrigger = ref(false);

    const editItem = async function (item) {
      root.$router.push({ name: "rbu-item", params: { itemId: item.id } });
    };

    return {
      filterOptions,

      headers,
      innerRefreshTrigger,

      editItem,

      PERMISSIONS,
    };
  },
};
</script>

<style lang="less">
.rbu-item-list {
}
.styled-span {
  cursor: pointer; /* Mouse pointer on hover */
  color: red; /* Red text */
  text-decoration: underline; /* Underline text */
}

.styled-span:hover {
  color: darkred; /* Optional: Darker red text on hover */
}
</style>
